import { render } from "./FooterLinks.vue?vue&type=template&id=1a34472f&scoped=true"
import script from "./FooterLinks.vue?vue&type=script&lang=js"
export * from "./FooterLinks.vue?vue&type=script&lang=js"

import "./FooterLinks.vue?vue&type=style&index=0&id=1a34472f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a34472f"]])

export default __exports__